import { useEffect, useState } from "react";

const TrackerTakeOverWarningModal = ({
  isOpen,
  ticketNumber,
  status,
  createdBy,
  isSubmitting = false,
  onCancel,
  onConfirm,
}) => {
  const [remarks, setRemarks] = useState("");

  useEffect(() => {
    if (isOpen) {
      setRemarks("");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[140] flex items-center justify-center bg-slate-950/50 px-4">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-5 shadow-2xl">
        <h3 className="text-lg font-semibold text-slate-900">Take Over Ticket</h3>
        <p className="mt-2 text-sm text-slate-700">
          You are about to take over ticket{" "}
          <span className="font-semibold text-slate-900">#{ticketNumber || "-"}</span>.
        </p>
        <p className="mt-1 text-sm text-slate-700">
          Status: <span className="font-semibold capitalize text-slate-900">{status || "-"}</span>
        </p>
        <p className="mt-1 text-sm text-slate-700">
          Created by: <span className="font-semibold text-slate-900">{createdBy || "-"}</span>
        </p>
        <p className="mt-3 text-sm text-slate-600">
          If you already have an active open ticket, it will be automatically moved to queue before this
          ticket is opened.
        </p>

        <label className="mt-4 block text-xs font-semibold uppercase tracking-wide text-slate-500">
          Remarks (Optional)
          <textarea
            value={remarks}
            onChange={(event) => setRemarks(event.target.value)}
            placeholder="Why are you taking over this ticket?"
            rows={3}
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-800 focus:border-blue-500 focus:outline-none"
            disabled={isSubmitting}
          />
        </label>

        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            onClick={() => {
              setRemarks("");
              onCancel();
            }}
            disabled={isSubmitting}
            className="rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 disabled:opacity-70"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onConfirm(remarks)}
            disabled={isSubmitting}
            className="rounded-lg bg-blue-600 px-3 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:opacity-70"
          >
            {isSubmitting ? "Processing..." : "Confirm Take Over"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrackerTakeOverWarningModal;
